document.addEventListener('DOMContentLoaded', function() {
  const slideshows = document.querySelectorAll('.slideshow');

  slideshows.forEach(slideshow => {
    const slides = slideshow.querySelector('.slides');
    const allSlides = slideshow.querySelectorAll('.slide');
    const dots = slideshow.querySelector('.dots');
    const prevButton = slideshow.querySelector('.arrow.prev');
    const nextButton = slideshow.querySelector('.arrow.next');
    let currentIndex = 0;
    let autoplayInterval;
    const autoplaySpeed = slideshow.dataset.autoplayspeed * 1000 || 5000; // Default 5 seconds

    function showSlide(index) {
        if (index < 0) {
            index = allSlides.length - 1;
        } else if (index >= allSlides.length) {
            index = 0;
        }

        slides.style.transform = `translateX(-${index * 100}%)`;
        currentIndex = index;

        if (dots) {
            dots.querySelectorAll('.dot').forEach((dot, i) => {
                dot.classList.toggle('active', i === index);
            });
        }
    }

    function startAutoplay() {
        autoplayInterval = setInterval(() => {
            showSlide(currentIndex + 1);
        }, autoplaySpeed);
    }

    function stopAutoplay() {
        clearInterval(autoplayInterval);
    }

    function adjustWidth() {
      if (window.innerWidth >= 768) { // Adjust breakpoint as needed (e.g., 768 for tablets and larger)
        slideshow.style.width = '50%';
        slideshow.style.margin = '0 auto'; // Center the slideshow
      } else {
        slideshow.style.width = '100%'; // Full width on mobile
        slideshow.style.margin = '0';
      }
    }

    // Call adjustWidth initially and on window resize
    adjustWidth();
    window.addEventListener('resize', adjustWidth);

    if(dots) {
        dots.querySelectorAll('.dot').forEach((dot, index) => {
            dot.addEventListener('click', () => {
                showSlide(index);
                stopAutoplay();
                startAutoplay();
            })
        })
    }

    if (allSlides.length > 1) {
        if (prevButton) {
            prevButton.addEventListener('click', () => {
                showSlide(currentIndex - 1);
                stopAutoplay();
                startAutoplay();
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                showSlide(currentIndex + 1);
                stopAutoplay();
                startAutoplay();
            });
        }
        startAutoplay();
    }

      slideshow.dataset.autoplaySpeed = slideshow.querySelector('[data-autoplay-speed]')?.dataset.autoplaySpeed || 5;
  });
});